"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageAuctionForm = void 0;
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const block_tracker_hooks_1 = require("@hooks/block-tracker.hooks");
const auction_hooks_1 = require("@hooks/contracts/auction.hooks");
const flags_hooks_1 = require("@hooks/flags.hooks");
const button_1 = require("@shared-modules/components/button");
const number_1 = require("@utils/object/number");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const React = __importStar(require("react"));
const event_timer_1 = require("../event-timer");
const token_info_1 = require("../token-info");
const translation_hooks_1 = require("@hooks/translation.hooks");
require("./styles.scss");
const ManageAuctionForm = (props) => {
    const { auction, updateToken } = props;
    const translator = (0, translation_hooks_1.usePagesTranslation)("tokenPage.manageAuctionForm");
    const { flags, toggleFlag } = (0, flags_hooks_1.useFlags)({ isCanceling: false, isFinalizing: false });
    const paymentToken = (0, tokens_reducer_1.useTokenByAddress)(auction.paymentTokenAddress);
    const { waitBlock } = (0, block_tracker_hooks_1.useBlockTracker)(() => {
        updateToken();
        flags.isFinalizing && toggleFlag("isFinalizing");
        flags.isCanceling && toggleFlag("isCanceling");
    });
    const cancelAuction = (0, auction_hooks_1.useCancelAuction)(auction.tokenId, auction.contractAddress);
    const auctionFinalize = (0, auction_hooks_1.useAuctionFinalize)(auction.tokenId, auction.contractAddress);
    const hasBids = auction.bids.length > 0;
    const finalizeHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        toggleFlag("isFinalizing");
        try {
            const { blockNumber } = (yield auctionFinalize()) || {};
            waitBlock(blockNumber);
        }
        catch (error) {
            toggleFlag("isFinalizing");
        }
    });
    const cancelHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        toggleFlag("isCanceling");
        try {
            const { blockNumber } = (yield cancelAuction()) || {};
            waitBlock(blockNumber);
        }
        catch (error) {
            toggleFlag("isCanceling");
        }
    });
    const lastBid = auction.bids.sort((left, right) => new bignumber_js_1.default(right.amount).minus(left.amount).toNumber())[0];
    const isProcessing = flags.isCanceling || flags.isFinalizing;
    const isAuctionExpired = auction.endAuctionDate < new Date().getTime();
    const auctionInfo = [
        {
            label: lastBid ? translator("currentBid") : translator("minBid"),
            currencySymbol: paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.symbol,
            value: lastBid
                ? (0, number_1.formatAndNormalizeToken)(paymentToken, lastBid === null || lastBid === void 0 ? void 0 : lastBid.amount, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals)
                : (0, number_1.formatAndNormalizeToken)(paymentToken, auction.minPrice, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals),
        },
    ];
    return (React.createElement("div", { className: "c-token-page-manage-auction-form" },
        React.createElement(event_timer_1.EventTimer, { startTime: auction.startAuctionDate, endTime: auction.endAuctionDate, onUpdate: updateToken, eventName: translator("eventName") }),
        React.createElement(token_info_1.TokenInfo, { cells: auctionInfo }),
        hasBids && React.createElement("b", { className: "c-token-page-manage-auction-form__warning" }, translator("hasBidWarning")),
        React.createElement("div", { className: "c-token-page-manage-auction-form__buttons" },
            hasBids && (React.createElement(button_1.Button, { disabled: !isAuctionExpired || isProcessing, loading: flags.isFinalizing, onClick: finalizeHandler }, translator("finalizeButton"))),
            !hasBids && (React.createElement(button_1.Button, { type: "thirtery", disabled: isProcessing, loading: flags.isCanceling, onClick: cancelHandler }, translator("cancelButton"))))));
};
exports.ManageAuctionForm = ManageAuctionForm;
